export const FAVORITES_COLUMN = 'favoritos';
export const MOVIES_ADMIN_ROUTE = '/laboratorio/filmes/area-administrativa';

export const DEFAULT_FAVORITE_CATEGORY_ORDER = ['series', 'filmes', 'animacoes'];

export const CATEGORY_STYLE_BY_KEY = {
  series: {
    label: 'Series',
    accentClassName: 'bg-blue-100 text-blue-700 border-blue-200',
    emptyMessage: 'Nenhum favorito enviado nessa categoria ainda.',
  },
  filmes: {
    label: 'Filmes',
    accentClassName: 'bg-amber-100 text-amber-700 border-amber-200',
    emptyMessage: 'Nenhum filme favorito enviado ainda.',
  },
  animacoes: {
    label: 'Animacoes',
    accentClassName: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    emptyMessage: 'Nenhuma animacao favorita enviada ainda.',
  },
};

export const MOVIE_GROUPS = [
  {
    id: 'assistidos',
    column: 'assistidos',
    eyebrow: 'Lista 02',
    title: 'Ja assisti',
    description:
      'Primeiro rascunho de filmes vistos recentemente ou revisitados ao longo do tempo.',
    items: [
      { title: 'Interstellar', note: 'Uma ficcao cientifica emotiva e ambiciosa.' },
      {
        title: 'Spider-Man: Into the Spider-Verse',
        note: 'Animacao inventiva e muito bem resolvida.',
      },
      { title: 'Top Gun: Maverick', note: 'Direto ao ponto, tecnico e empolgante.' },
    ],
  },
  {
    id: 'quero-ver',
    column: 'quero-ver',
    eyebrow: 'Lista 03',
    title: 'Quero assistir',
    description:
      'Espaco para filmes que quero pesquisar melhor, assistir em breve ou revisitar com outro olhar.',
    items: [
      { title: 'Dune: Part Two', note: 'Na lista pela escala visual e pelo universo.' },
      { title: 'The Holdovers', note: 'Curiosidade pela atmosfera e pelos personagens.' },
      { title: 'Perfect Days', note: 'Quero ver com calma pelo tom mais contemplativo.' },
    ],
  },
];

export const MOVIES_NEXT_STEPS = [
  'Adicionar busca por titulo usando API externa.',
  'Salvar status como assistido, favorito ou quero ver.',
  'Incluir nota pessoal e pequenas observacoes por filme.',
];

export const ALLOWED_COLUMNS = ['favoritos', 'assistidos', 'quero-ver'];
